import React from 'react'
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import PromotionalBannerQueryListComponent from '../../Components/PromotionalBannerQueryListComponent/PromotionalBannerQueryListComponent'

const PromotionalBannerQueryList = () => {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header/>
      <PromotionalBannerQueryListComponent/>
      <Footer/>
    </div>
  )
}

export default PromotionalBannerQueryList
